import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "appointment-data-card-skeleton",
      style: { height: `${_vm.height}px` },
    },
    [
      !_vm.withoutAvatar
        ? _c(VSkeletonLoader, {
            staticClass: "flex-shrink-0 mr-4",
            attrs: { type: "avatar", width: _vm.width, height: _vm.height },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(VSkeletonLoader, {
        staticClass: "my-auto w-100",
        attrs: { type: "text@2" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }